export default {
  invoices(state) {
    return state.invoices
  },
  proFormaInvoices(state) {
    return state.proFormaInvoices
  },
  cnDns(state) {
    return state.cnDns
  },
  billingdocsCount(state) {
    return state.billingdocsCount
  },
  preEinvoiceCreationCount(state) {
    return state.preEinvoiceCreationCount
  },
  summary(state) {
    return state.summary
  },
  consolidated(state) {
    return state.consolidated
  },
  selfBilled(state) {
    return state.selfBilled
  },
  orders(state) {
    return state.orders
  },
  orderSummary(state) {
    return state.orderSummary
  },
}
